<template>
  <b-loading :is-full-page="true" :active="isPreloading" :can-cancel="false"></b-loading>
</template>

<script>
export default {
  name: 'Preloader',
  props: {
    isPreloading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
